import axios, { AxiosRequestConfig } from 'axios';
import { getAuthToken } from "../components/security/AuthContext";

export const API_URL = process.env.REACT_APP_API_URL || "https://cometai.ru/api";
export const WS_API_URL = process.env.REACT_APP_WS_URL || "wss://cometai.ru/ws";

// Helper to construct full URL with base

export const apiRequest = async (
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
  url: string,
  data?: any
) => {
  const config: AxiosRequestConfig = {
    method,
    url: url,  // Ensure the full URL is used
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getAuthToken()}`,
    },
    data, // Optional payload for POST/PUT
  };

  try {

    const response = await axios(config);

    return response.data;
  } catch (error: any) {

    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      window.location.href = '/login';
      return;
    }

    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Server error occurred during the API request.';
    throw new Error(message);
  }
};
